
/**   
 * 文章api管理
 */

import base from "./base";

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || '、api'
console.log(apiBaseUrl)

const xhr = new base(apiBaseUrl);

// 新闻列表
export const GetNewsList = (pars) => {
  return xhr({
    url: "/Home/GetNewsList",
    method: "get",
    params: pars,
  })
}

export const GetNews = (id) => {
  return xhr({
    url: "/Home/GetNews",
    method: "get",
    params: { id },
  })
}


// 职位列表
export const GetPositionList = (pars) => {
  return xhr({
    url: "/Home/GetPositionList",
    method: "get",
    params: pars,
  })
}

export const GetPosition = (id) => {
  return xhr({
    url: "/Home/GetPosition",
    method: "get",
    params: { id },
  })
}

// 分类 树
export const GetPositionCategory = () => {
  return xhr({
    url: "/Home/GetPositionCategory",
    method: "get",
  })
}

